export class Audiencia {
  id: number;
  dataInicio: string;
  processoId: number;
  processoNumero: string;
  documentoAutosId: number;
  origemId: number;
  local: string;
  status: number;
  processo?: { titulo: string };
}
